import { Maybe } from 'graphql/jsutils/Maybe';
import React from 'react';
import { ChatbotInput, UserMessage } from 'Assistant/Chatbot';
import useViewportWidth from 'utils/useViewportWidth';
import { Breakpoints } from '@unmind/design-system-theme';
import { useSubmitInitialMessage } from 'Assistant/Chatbot/hooks';
import { isMSTeams } from 'utils/MSTeams';
import { useHistory } from 'react-router';
import RoutePath from 'App/RoutePath';
import { useTranslation } from 'react-i18next';
import * as S from './styles';
import { ChatbotStarters } from './ChatbotStarters';

type ChatbotBannerProps = {
  firstName: Maybe<string>;
};

const ChatbotBanner = ({ firstName }: ChatbotBannerProps) => {
  const viewportWidth = useViewportWidth();
  const { t: translate } = useTranslation('homepage');
  const history = useHistory();
  const isMobileWeb = viewportWidth < Breakpoints.XS;
  const [shouldSubmitInitialMessage, setSubmitInitialMessage] =
    useSubmitInitialMessage();

  const handleSubmitRedirect = async (message: UserMessage) => {
    if (!shouldSubmitInitialMessage) {
      await setSubmitInitialMessage(true);
    }

    if (isMSTeams()) {
      history.push(
        `${RoutePath.Chatbot}?content=${message.content}&topic=${message.topic}&starterId=${message.starterId}`,
      );
    } else {
      history.push(RoutePath.Chatbot, message);
    }
  };

  const greeting =
    isMobileWeb && !isMSTeams()
      ? translate('chatbot_banner.greeting_generic')
      : translate('chatbot_banner.greeting_personal', { name: firstName });

  return (
    <S.ChatbotBannerContainer>
      <S.ChatbotBannerTitleContainer data-testid="chatbot-banner-title-container">
        <S.AssistantIcon aria-hidden={true} />
        <S.ChatbotBannerTitle>{greeting}</S.ChatbotBannerTitle>
      </S.ChatbotBannerTitleContainer>
      <S.ChatbotInputContainer>
        <ChatbotInput
          canSubmit={true}
          onSubmit={handleSubmitRedirect}
          displayOnHomepage={true}
        />
      </S.ChatbotInputContainer>
      <ChatbotStarters handleSubmitRedirect={handleSubmitRedirect} />
    </S.ChatbotBannerContainer>
  );
};

export default ChatbotBanner;
